import type { OptionsDocument, UserPreferences } from 'paintscout'
import uniq from 'lodash/uniq'
import { getFeature } from '../../options/get-features'

/**
 * Get follow ups from options or user based on settingsCommunications feature
 */
export function getFollowUps({ preferences, options }: { preferences: UserPreferences; options: OptionsDocument }) {
  const hasSettingsCommunications = getFeature({ options, path: 'settingsCommunications.enabled' })
  if (hasSettingsCommunications) {
    const order = options.options?.emails?.followUps?.order ?? []
    return {
      order: uniq(order),
      values: options.options?.emails?.followUps?.values ?? {}
    }
  } else {
    const order = preferences?.emails?.followUps?.order ?? []
    return {
      order: uniq(order),
      values: preferences?.emails?.followUps?.values ?? {}
    }
  }
}
